import { v4 as uuidv4 } from "uuid";
import { useGetDataQuery } from "features/apiSlice";
import { useMemo, useState } from "react";
import Target from "./Target";
import { CUSTOM_DROPDOWN_LIST } from "layouts/nms/configs/dropdownConfigs";

import { Draggable } from "@hello-pangea/dnd";
import { Card, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import ContextMenu from "layouts/nms/widgets/ContextMenu";
import Dropdown from "layouts/nms/Dropdown";

function Custom({
  widgetHeight,
  widget,
  cellWidgetInfo,
  index,
  masterContainerId,
  cellId,
  handleDeleteWidget,
  containerType,
  isEditMode,
  isAdmin,
}) {
  const getDataURL = widget.getDataURL;
  const refreshInterval = widget.refreshInterval ? widget.refreshInterval : 0;

  const customWidgetDataQuery = getDataURL
    ? useGetDataQuery(getDataURL, {
        pollingInterval: refreshInterval,
        refetchOnReconnect: true,
      })
    : {};

  const [contextMenu, setContextMenu] = useState(null);

  const handleContextMenu = (event) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6,
          }
        : null,
    );
  };

  const handleClose = () => setContextMenu(null);

  const draggableId = `${cellWidgetInfo.widgetType}/////${
    cellWidgetInfo.id
  }/////${uuidv4()}`;

  let primaryLabel = null;
  let secondaryLabel = null;
  let targetWidget = null;
  let error = null;
  if (customWidgetDataQuery.data) {
    primaryLabel = widget.primaryLabel ? widget.primaryLabel : "";
    secondaryLabel = widget.secondaryLabel ? widget.secondaryLabel : "";
    targetWidget = <Target data={customWidgetDataQuery.data} widget={widget} />;
  } else {
    primaryLabel = "Unable to update the widget";
    secondaryLabel = "";
    targetWidget = null;
    error = (
      <Icon
        sx={{ marginLeft: "auto", marginTop: ".3em", color: "red" }}
        fontSize="medium"
      >
        warningambericon
      </Icon>
    );
  }

  const renderCustomWidget = (
    <MDBox p={2} position="relative" height={widgetHeight}>
      <MDBox
        width="2.5rem"
        height="2.5rem"
        bgColor="info"
        variant="gradient"
        coloredShadow="info"
        borderRadius="lg"
        display="flex"
        justifyContent="center"
        alignItems="center"
        color="white"
        position="absolute"
        top="-.7em"
      >
        <Icon fontSize="small">widgets_icon</Icon>
      </MDBox>
      <MDBox display="flex" justifyContent="space-between" width="100%" mb={1}>
        <MDBox ml={6}>
          <MDTypography variant="h6">{primaryLabel}</MDTypography>
          <MDTypography component="div" variant="button" color="text">
            {secondaryLabel}
          </MDTypography>
        </MDBox>
        {error}
        {isEditMode && isAdmin && (
          <Dropdown
            handleDeleteWidget={handleDeleteWidget}
            masterContainerId={masterContainerId}
            cellId={cellId}
            index={index}
            options={CUSTOM_DROPDOWN_LIST}
          />
        )}
      </MDBox>
      {useMemo(() => targetWidget, [customWidgetDataQuery.data])}
    </MDBox>
  );

  const pdfExportId = `${primaryLabel}/${cellWidgetInfo.id}`;

  return isEditMode ? (
    <Draggable draggableId={draggableId} index={index}>
      {(provided) => (
        <Card
          sx={{
            flexGrow: "1",
            flexBasis: "0",
            margin: ".5em",
            marginTop:
              index > 0 && containerType === "vertical" ? "1em" : "0.5em",
          }}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
        >
          {renderCustomWidget}
        </Card>
      )}
    </Draggable>
  ) : (
    <Card
      sx={{
        flexGrow: "1",
        flexBasis: "0",
        margin: ".5em",
        marginTop: index > 0 && containerType === "vertical" ? "1em" : "0.5em",
        cursor: "context-menu",
      }}
      onContextMenu={handleContextMenu}
      id={pdfExportId}
    >
      {renderCustomWidget}
      <ContextMenu
        id={pdfExportId}
        contextMenu={contextMenu}
        handleClose={handleClose}
        name={primaryLabel}
      />
    </Card>
  );
}

export default Custom;
